import React, { useState, useEffect } from "react";
import { imgDb } from "../../firebase";
import { v4 } from "uuid";
import { ref, uploadBytes } from "firebase/storage";
import { useAuth } from "../../context/authContext";
import { app } from "../../firebase";

function MoreInfo({ formData, setFormData, croquis, setCroquis }) {
  const [mensaje, setMensaje] = useState('Sube un archivo');
  const handleSelectChange = (event) => {
    const name = event.target.name;
    const value = event.target.value;

    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const { user } = useAuth();
  const timestamp = new Date();
  const handleClick = () => {
    const imgRef = ref(
      imgDb,
      `${user.displayName}&${timestamp.toISOString()}/${v4()}`
    );
    uploadBytes(imgRef, croquis);
  };

  //------lo nuevo------

  const archivoHandler = async (e) => {
    e.preventDefault();
    const archivo = e.target.files[0];
    const storageRef = app.storage().ref();
    const archivoPath = storageRef.child(archivo.name);
    try {
    await archivoPath.put(archivo);
    console.log("archivo cargado:", archivo.name);
    const enlaceUrl = await archivoPath.getDownloadURL();
    console.log(enlaceUrl);
    setFormData({
      ...formData,
      enlaceUrl: enlaceUrl,
    });
    // Establecer el mensaje de éxito
    setMensaje('   ¡Archivo cargado exitosamente!');
  } catch (error) {
    console.error('Error al cargar el archivo:', error);
    // Puedes establecer un mensaje de error si es necesario
    setMensaje('Hubo un error al cargar el archivo. Por favor, inténtalo de nuevo.');
  }
};

    
  


  const submitHandler = async (e) => {
    e.preventDefault();
    /* const nombreArchivo = e.target.nombre;
    if (!nombreArchivo) {
      alert("coloca un nombre")
      return
    }
    const coleccionRef = app
      .firestore()
      .collection(`${user.displayName}&${timestamp.toISOString()}`);
    await coleccionRef
      .doc(nombreArchivo)
      .set({ nombre: nombreArchivo, url: formData });
    //console.log("archivo cargado:", nombreArchivo, "ulr:", archivoUrl);
    window.location = "/";*/
  };

  useEffect(() => {
    async function fetchData() {
      const docusList = await app
        .firestore()
        .collection(`${user.displayName}&${timestamp.toISOString()}`)
        .get();
      setCroquis(docusList.docs.map((doc) => doc.data()));
    }
    fetchData();
  }, []);

  //------fin lo nuevo------------------

  return (
    <div className="more-info-container">
      <div>
        <label htmlFor="spt" className="form-label">
          Valor SPT (ohm)
        </label>
        <input
          type="number"
          min={0.1}
          placeholder="Ingrese los valores obtenidos del sistema a puesta a tierra."
          value={formData.spt}
          onChange={(e) => setFormData({ ...formData, spt: e.target.value })}
          required
        />
      </div>

      <div>
        <label htmlFor="ohmnimetro" className="form-label">
          Modelo telurímetro
        </label>
        <input
          type="text"
          placeholder="Ingrese la marca y modelo de ohmnimetro"
          value={formData.ohmnimetro}
          onChange={(e) =>
            setFormData({ ...formData, ohmnimetro: e.target.value })
          }
          style={{ textTransform: "capitalize" }}
          required
        />
      </div>

   

      <div>
        <label htmlFor="ohmnimetro" className="form-label">   <br></br>
          Croquis de instalación
        </label>
       
        <input type="file" onChange={archivoHandler} />

        {/* Mostrar el mensaje */}
      {mensaje && <p>{mensaje}</p>}
        
      </div>
    </div>
  );
};

export default MoreInfo;
